import React from 'react';

import TableWidgetResourceLibraryNoYear from '../../../../../cyder/table/TableWidgetResourceLibraryNoYear';

const MemberResourcesDownloads = ({ downloads }) => <TableWidgetResourceLibraryNoYear items={downloads} />;

export default MemberResourcesDownloads;
